import { REGISTER_STAGE } from '@/store/modules/profile';

export const BACK_ACTION_TYPE = {
  ROUTER: 'router',
  STAGE: 'stage',
  NONE: 'none',
};

export const REGISTER_STAGE_CONFIG = {
  [REGISTER_STAGE.FILL_BIO]: {
    name: 'Bio',
    showBackButton: true,
    stepNumber: 1,
    stepTotal: 3,
    backActionType: BACK_ACTION_TYPE.ROUTER,
  },

  [REGISTER_STAGE.FILL_CONTACT]: {
    name: 'Contact',
    showBackButton: true,
    stepNumber: 2,
    stepTotal: 3,
    backActionType: BACK_ACTION_TYPE.STAGE,
    previousStage: REGISTER_STAGE.FILL_BIO,
  },

  [REGISTER_STAGE.FILL_LIFESTAGE]: {
    name: 'Life Stage',
    showBackButton: true,
    stepNumber: 3,
    stepTotal: 3,
    backActionType: BACK_ACTION_TYPE.STAGE,
    previousStage: REGISTER_STAGE.FILL_CONTACT,
    shouldDisableBack: hasRegistered => hasRegistered === 'STAGE_2_CONTACT_COMPLETED_REGISTRATION',
  },

  [REGISTER_STAGE.VERIFY_OTP]: {
    name: 'Verify OTP',
    showBackButton: true,
  },

  [REGISTER_STAGE.OTP_VERIFIED]: {
    name: 'OTP Verified',
    showBackButton: true,
  },

  [REGISTER_STAGE.SET_PASSWORD]: {
    name: 'Set Password',
    showBackButton: true,
  },

  [REGISTER_STAGE.COMPLETED]: {
    name: 'Completed',
    showBackButton: false,
  },
};

export const TOTAL_STEPS = 4; // Based on the template: 0, 1, 2, 3, 4 (PasswordCreated)

/**
 * Helper function to get configuration for a specific stage
 */
export const getStageConfig = stage => {
  return REGISTER_STAGE_CONFIG[stage];
};
